import { useMemo } from "react";
import {
  useGetPermissionsQuery,
  type Permission,
} from "../../../../features/api/permissionsApi";

export default usePermissions;

export type UsePermissionsHookResult = {
  data: Set<Permission>;
  isUninitialized: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  isFetching: boolean;
};

function usePermissions(): UsePermissionsHookResult {
  const {
    data: permissions = [],
    isUninitialized,
    isLoading,
    isSuccess,
    isError,
    isFetching,
  } = useGetPermissionsQuery(undefined);
  const data = useMemo(
    () => new Set(permissions.map(({ permission }) => permission)),
    [permissions],
  );
  return {
    isUninitialized,
    isLoading,
    isSuccess,
    isError,
    isFetching,
    data,
  };
}
